import React, { useState } from 'react';
import Header from './Header';
import Video from './Video';
import './App.css';

function App() {
  var tempLang = localStorage.getItem('tadokuLang') ? localStorage.getItem('tadokuLang') : 'jpjp';
  const [lang, setLang] = useState(tempLang);

  return (
    <>
      <div id="wrapper">
        <Header lang={lang}/>
        <div className="container">
          <div className="c3">
            <form className="right">
              <label>
                <i className="fas fa-language"></i>
                <select value={lang} onChange={(e)=>{
                  setLang(e.target.value);
                  localStorage.setItem('tadokuLang', e.target.value);
                }}>
                  {/* <optgroup label="日本語">
                    <option value="jpng">日本語音声、字幕なし</option>
                    <option value="jpkn">日本語音声、かな字幕</option>
                    <option value="jpjp">日本語音声、日本語字幕</option>
                  </optgroup>
                  <optgroup label="English">
                    <option value="enng">English audio, No subtitles</option>
                    <option value="enen">English audio, English subtitles</option>
                  </optgroup> */}
                  <option value="jpjp">日本語</option>
                  <option value="enen">English</option>
                </select>
              </label>
            </form>
            <Video lang={lang}/>
          </div>
        </div>
      </div>
    </>
  );
};

export default App;